<template>
  <section class="c_result">
    <h2 class="c_result_ttl">コンテンツ一覧</h2>
    <!--
    <div class="c_result_filter">
      <label class="c_result_select">
        <select>
          <option value>新着順</option>
        </select>
      </label>
      <div class="c_result_srch">
        <label class="c_result_srch">
          <input
            type="text"
            placeholder="キーワード検索"
            v-model="search"
            @keyup.prevent.enter="doSearch"
          />
        </label>
        <button type="submit">
          <span class="icon-search"></span>
        </button>
      </div>
    </div>
    -->
    <div class="c_result_list">
      <div class="c_tool_item" v-for="c in contents" :key="c.id">
        <figure class="c_tool_item_img">
          <img
            v-if="c.image_path"
            :src="c.image_path"
            alt
            width="90"
            height="90"
          />
          <img
            v-else
            src="https://placehold.jp/cfcfcf/4a4a4a/90x90.png?text=NO%0AIMAGE"
            alt
            width="90"
            height="90"
          />
        </figure>
        <div class="c_tool_item_cnt">
          <p class="c_tool_item_ttl">
            <em>{{ c.title }}</em>
            <span v-if="c.required" class="-required">必須</span>
            <span
              v-if="Boolean(c.progress && c.progress.completed_at)"
              class="-end"
            >
              完了
            </span>
          </p>
          <p class="c_tool_item_disc">{{ c.description }}</p>
        </div>
        <div class="c_tool_item_link">
          <a class="c_tool_item_link" @click="clickContents(c)">
            {{ goContentsText(c) }}
          </a>
        </div>
      </div>
      <div :class="{ c_load: loading }"></div>
    </div>
    <div class="c_result_btn">
      <button class="c_btn -large" type="button" v-if="next" @click="getNext">
        さらに表示
      </button>
    </div>
    <div v-if="!response_date" style="text-align: center; padding:20px;">
      事前アンケート回答後に、コンテンツを視聴できます。
    </div>
    <div
      v-else-if="!loading && contents.length === 0"
      style="text-align: center; padding:20px;"
    >
      学習可能なコンテンツはありません。
    </div>
  </section>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      contents: [],
      page: 1,
      next: false,
      loading: false,
      search: "",
      response_date: null
    };
  },
  created() {
    this.$authAxios.get("/api/responses/").then(response => {
      if (response.data.response_date) {
        this.response_date = response.data.response_date;
        this.fetch();
      }
    });
  },
  methods: {
    fetch() {
      this.loading = true;

      this.$authAxios
        .get(`/api/contents/`, {
          //params: {
          //  page: this.page,
          //  tool: 1,
          //  search: this.search,
          //},
        })
        .then(response => {
          //this.contents = this.contents.concat(response.data.results);
          this.contents = this.contents.concat(response.data);
          this.next = response.data.next;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    doSearch() {
      if (this.search) {
        this.contents = [];
        this.fetch();
      }
    },
    isNew(date) {
      // 3か月以内に作成されてればNEW
      return moment(date).isAfter(moment().subtract(3, "months"));
    },
    getNext() {
      this.page += 1;
      this.fetch();
    },
    clickContents(contents) {
      if (this.$auth.scopes.includes("readonly:npa")) {
        if (
          this.categoryId ===
          this.$store.getters.getCategoryIdByName(
            "サイバー関連サービス等解説コンテンツ"
          )
        ) {
          this.goContents(contents);
        } else {
          this.$modal.show("unauthorized");
        }
      } else {
        this.goContents(contents);
      }
    },
    goContents(contents) {
      if (contents.content_type === "pdf") {
        this.$router.push({ name: "PDFSingle", params: { id: contents.id } });
      } else if (contents.content_type === "video") {
        this.$router.push({ name: "VideoSingle", params: { id: contents.id } });
      } else if (contents.content_type === "survey") {
        this.$router.push({
          name: "SurveySingle",
          params: { id: contents.id }
        });
      }
    },
    goContentsText(contents) {
      if (contents.content_type === "pdf") {
        return "閲覧する";
      } else if (contents.content_type === "video") {
        return "視聴する";
      } else {
        return "開始する";
      }
    },
    accessableStyle(contents) {
      if (!contents.accessable) {
        return {
          "pointer-events": "none",
          background: "gainsboro"
        };
      }
    },
    searchTag(tag) {
      this.$router.push({ name: "Search", query: { tag: tag } });
    }
  }
};
</script>

<style scoped>
.c_result_list {
  margin-top: 20px;
}

.-required {
  color: #fff;
  font-weight: bold;
  font-size: 12px;
  background: #d00000;
  display: inline-block;
  padding: 0 10px;
  line-height: 17px;
  height: 17px;
  margin-left: 10px;
}

.-end {
  color: #fff;
  font-weight: bold;
  font-size: 12px;
  background: #78ba00;
  display: inline-block;
  padding: 0 10px;
  line-height: 17px;
  height: 17px;
  margin-left: 10px;
}
</style>
